// testimonialsPagejs

import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import TestimonialCard from "../../02-molecules/testimonialCard/TestimonialCard";
import SEO from "../../02-molecules/SEO/SEO";
import Breadcrumb from "../../01-atoms/breadcrumbs/Breadcrumbs";

const TestimonialsPage = (props) => {
    const { dataArray, assetsArray, handleLoading } = props;

    // Filtering data to get an array of Testimonials
    const testimonialsArray = dataArray.filter((data) => data.fields.contentType.toLowerCase() === 'testimonials');

    // Mapping products and associating them with their images
    const testimonialAssetArray = testimonialsArray.map((testimonial) => ({
        testimonial,
        image: assetsArray.filter((asset) => testimonial.fields.reviewerName.toLowerCase() === asset.fields.title.toLowerCase()),
    }));

    return(
        <main className="secondary-page__content">
            <div className="wrapper wrapper-secondary">
                <Breadcrumb />

                <SEO
                    title='Reviews & Testimonials | Ajit Furniture House'
                    description='Read Customer Reviews & Testimonials'
                    name='Ajit Furniture House'
                    type='reviews'
                />

                <div className="content-container">
                    <div className="testimonials-page">
                        <div className="testimonials-page__heading secondary-page__heading">
                            <h2>TESTIMONIALS</h2>
                        </div>

                        <div className="testimonials-page__main">
                            <ResponsiveMasonry columnsCountBreakPoints={{500: 1, 501: 2, 900: 3}}>
                                <Masonry gutter="2rem">
                                {testimonialAssetArray.map((review) => {
                                    return (
                                        <TestimonialCard key={review.testimonial.sys.id} review={review} isHomePage={false} handleLoading={handleLoading}/>
                                    )
                                })}
                                </Masonry>
                            </ResponsiveMasonry>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default TestimonialsPage;